/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Row } from "reactstrap"
import { Fieldset } from "../../../Components/Fieldset/Fieldset"
import { FormContainer } from "../../../Components/Forms/FormContainer/FormContainer"
import AppLayout from "../../../Components/Layout/Layout"
import PageTitle from "../../../Components/PageTitle/PageTitle"
import { FormField } from "../../../Components/Forms/FormField/FormField"
import { Label } from "../../../Components/Forms/Label/Label"
import { Input } from "../../../Components/Forms/Input/Input"
import { useEffect, useState } from "react"
import { IContrato } from "../../../Dtos/Comercial/Contratos/ContratosDtos"
import { IToastOpcoes, Toast } from "../../../Components/Toast/Toast"
import { InputData } from "../../../Components/Forms/InputData/InputData"
import { MonetaryInput } from "../../../Components/Forms/MonetaryInput/MonetaryInput"
import { ButtonPrimary } from "../../../Components/Forms/SaveButton/SaveButton"
import { ButtonSecundary } from "../../../Components/Forms/CancelButton/CancelButton"
import LoadingPage from "../../../Components/Loading/Loading"
import { useNavigate, useParams } from "react-router-dom"
import ApiService from "../../../Config/ApiConfig"
import { UltAlt } from "../../../Components/UltAlt/UltAlt"

export const FormContratoPage = () => {
    const { sd43id, sd48id } = useParams()
    const navigate = useNavigate()
    const [formData, setFormData] = useState<IContrato>({} as IContrato)
    const [inEdicao, setInEdicao] = useState(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [toastOpcoes, setToastOpcoes] = useState<IToastOpcoes>({ type: "info", visible: false, mensagem: "" })

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Licenças" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        if (sd43id != null) {
            setInEdicao(true)
            buscarDadosProposta()
        }
        if (sd48id != null) buscarDadosContrato()
    }, [])

    const buscarDadosContrato = async () => {
        try {
            setLoading(true)

            const api = new ApiService();
            const dados = await api.get<IContrato>("/sd48Controller/buscarContratoPeloId", { params: { sd48id: sd48id } })
            
            setFormData(dados)

        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar informações! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const buscarDadosProposta = async () => {
        try {
            setLoading(true)

            const api = new ApiService();
            const dados = await api.get<{ sd40: any, sd41: any, sd432valorhora: number }>("/sd48Controller/buscarDadosPropeccao", { params: { sd43id: sd43id } })
            
            setFormData(prev => ({
                ...prev,
                sd48representante: dados.sd41,
                sd48cliente: dados.sd40,
                sd48valorhora: dados.sd432valorhora
            }))
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar informações! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCahngeValoresContrato = (nome: string, value: number) => {
        setFormData(prev => ({
            ...prev,
            [nome]: value
        }));
    }

    const handleBtnCancelar = () => {
        setInEdicao(false)
    }

    const handleBtnSalvar = async () => {
        try {
            setLoading(true)

            const dados = {
                sd43id: sd43id,
                ...formData
            }
            
            

            const apiService = new ApiService()
            await apiService.post("/sd48Controller/gravarContrato", dados)

            navigate("/contratos")
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao salvar! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }

    }

    const btnSolicitar = async () => {
        try {
            setLoading(true)

            const apiService = new ApiService()
            await apiService.post("/sd48Controller/solicitarLicenca/" + sd48id)

            navigate("/solicitacoes")
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao solicitar! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const btnImprimir = async () => {
        try {
            setLoading(true)

            const apiService = new ApiService()
            const pdfBytes = await apiService.get("/sd48Controller/imprimirContrato", { params: { sd48id: sd48id }, responseType: 'arraybuffer' })

            //@ts-ignore
            const blob = new Blob([pdfBytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            window.open(url, '_blank');

        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao solicitar! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const closeToast = () => {
        setToastOpcoes({ type: "info", visible: false, mensagem: "" })
    }

    if (loading) {
        return (
            <LoadingPage />
        )
    }
    return (
        <AppLayout>
            <Toast
                isVisible={toastOpcoes.visible}
                message={toastOpcoes.mensagem}
                onClose={closeToast}
                type={toastOpcoes.type}
            />
            <PageTitle title="Contrato" />
            <FormContainer>
                <Fieldset legend="Contrato">
                    <Row>
                        <Col md="4">
                            <FormField >
                                <Label>Código</Label>
                                <Input
                                    value={formData.sd48codigo?.toString() ?? ""}
                                    onChange={() => { }}
                                    disabled
                                />
                            </FormField>
                        </Col>
                        <Col md="4">
                            <FormField >
                                <Label>Multa</Label>
                                <MonetaryInput
                                    value={formData.sd48multa ?? 0}
                                    onChange={(value) => handleCahngeValoresContrato("sd48multa", value)}
                                    disabled={!inEdicao}
                                />
                            </FormField>
                        </Col>
                        <Col md="4">
                            <FormField >
                                <Label>Valor da Hora Tecnica</Label>
                                <MonetaryInput
                                    value={formData.sd48valorhora ?? 0}
                                    onChange={(value) => handleCahngeValoresContrato("sd432valorhora", value)}
                                    disabled
                                />
                            </FormField>
                        </Col>
                    </Row>
                </Fieldset>
                <Fieldset legend="Representante" marginTop="15px">
                    <Row>
                        <Col md="4">
                            <FormField >
                                <Label>CNPJ</Label>
                                <Input
                                    type="text"
                                    name="sd48representante"
                                    value={formData?.sd48representante?.sd41cnpj ?? ""}
                                    onChange={handleChange}
                                    disabled
                                />
                            </FormField>
                        </Col>
                        <Col md="4">
                            <FormField >
                                <Label>Nome</Label>
                                <Input
                                    type="text"
                                    name="sd48representante"
                                    value={formData?.sd48representante?.sd41nome ?? ""}
                                    onChange={handleChange}
                                    disabled
                                />
                            </FormField>
                        </Col>
                        <Col md="4">
                            <InputData
                                name="sd48representante"
                                initialValue={formData.sd48representante?.sd41dtinicio}
                                label="Data"
                                onChange={(_) => { }}
                                disabled
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormField >
                                <Label>Endereço</Label>
                                <Input
                                    type="text"
                                    name="sd48representante"
                                    value={formData?.sd48representante?.sd41endereco ?? ""}
                                    onChange={handleChange}
                                    disabled
                                />
                            </FormField>
                        </Col>
                        <Col md="4">
                            <FormField >
                                <Label>Número</Label>
                                <Input
                                    type="text"
                                    name="sd48representante"
                                    value={formData?.sd48representante?.sd41numero ?? ""}
                                    onChange={handleChange}
                                    disabled
                                />
                            </FormField>
                        </Col>
                        <Col md="4">
                            <FormField >
                                <Label>Bairro</Label>
                                <Input
                                    type="text"
                                    name="sd48representante"
                                    value={formData?.sd48representante?.sd41bairro ?? ""}
                                    onChange={handleChange}
                                    disabled
                                />
                            </FormField>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormField >
                                <Label>Representante</Label>
                                <Input
                                    type="text"
                                    name="sd48repsocio"
                                    value={formData?.sd48repsocio ?? ""}
                                    onChange={handleChange}
                                    disabled={!inEdicao}
                                />
                            </FormField>
                        </Col>
                        <Col md="3">
                            <FormField >
                                <Label>RG</Label>
                                <Input
                                    type="text"
                                    name="sd48reprg"
                                    value={formData?.sd48reprg ?? ""}
                                    onChange={handleChange}
                                    disabled={!inEdicao}
                                    validation="numbers"
                                />
                            </FormField>
                        </Col>
                        <Col md="3">
                            <FormField >
                                <Label>CPF</Label>
                                <Input
                                    type="text"
                                    name="sd48repcpf"
                                    value={formData?.sd48repcpf ?? ""}
                                    onChange={handleChange}
                                    disabled={!inEdicao}
                                    validation="numbers"
                                />
                            </FormField>
                        </Col>
                    </Row>
                </Fieldset>
                <Fieldset legend="Cliente" marginTop="15px">
                    <Row>
                        <Col md="4">
                            <FormField >
                                <Label>CNPJ</Label>
                                <Input
                                    type="text"
                                    name="sd48cliente"
                                    value={formData?.sd48cliente?.sd40cnpj ?? ""}
                                    onChange={handleChange}
                                    disabled
                                />
                            </FormField>
                        </Col>
                        <Col md="8">
                            <FormField >
                                <Label>Nome</Label>
                                <Input
                                    type="text"
                                    name="sd48cliente"
                                    value={formData?.sd48cliente?.sd40nome ?? ""}
                                    onChange={handleChange}
                                    disabled
                                />
                            </FormField>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormField >
                                <Label>Endereço</Label>
                                <Input
                                    type="text"
                                    name="sd48cliente"
                                    value={formData?.sd48cliente?.sd40endereco ?? ""}
                                    onChange={handleChange}
                                    disabled
                                />
                            </FormField>
                        </Col>
                        <Col md="4">
                            <FormField >
                                <Label>Número</Label>
                                <Input
                                    type="text"
                                    name="sd48cliente"
                                    value={formData?.sd48cliente?.sd40numero ?? ""}
                                    onChange={handleChange}
                                    disabled
                                />
                            </FormField>
                        </Col>
                        <Col md="4">
                            <FormField >
                                <Label>Bairro</Label>
                                <Input
                                    type="text"
                                    name="sd48cliente"
                                    value={formData?.sd48cliente?.sd40bairro ?? ""}
                                    onChange={handleChange}
                                    disabled
                                />
                            </FormField>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormField >
                                <Label>Representante</Label>
                                <Input
                                    type="text"
                                    name="sd48clisocio"
                                    value={formData?.sd48clisocio ?? ""}
                                    onChange={handleChange}
                                    disabled={!inEdicao}
                                />
                            </FormField>
                        </Col>
                        <Col md="3">
                            <FormField >
                                <Label>RG</Label>
                                <Input
                                    type="text"
                                    name="sd48clirg"
                                    value={formData?.sd48clirg ?? ""}
                                    onChange={handleChange}
                                    disabled={!inEdicao}
                                    validation="numbers"
                                />
                            </FormField>
                        </Col>
                        <Col md="3">
                            <FormField >
                                <Label>CPF</Label>
                                <Input
                                    type="text"
                                    name="sd48clicpf"
                                    value={formData?.sd48clicpf ?? ""}
                                    onChange={handleChange}
                                    disabled={!inEdicao}
                                    validation="numbers"
                                />
                            </FormField>
                        </Col>
                    </Row>
                </Fieldset>
                <Row style={{ marginTop: "15px" }}>
                    {
                        (!inEdicao && sd48id == null) && <Col md="2">
                            <ButtonPrimary onClick={() => setInEdicao(true)} >
                                Editar
                            </ButtonPrimary>
                        </Col>
                    }
                    {
                        inEdicao && <Col md="4">
                            <ButtonSecundary onClick={handleBtnCancelar} >
                                Cancelar
                            </ButtonSecundary>
                            <ButtonPrimary onClick={handleBtnSalvar} >
                                Salvar
                            </ButtonPrimary>
                        </Col>
                    }
                </Row>
                {
                    sd48id != null && (
                        <Row>
                            <Col md="2">
                                <ButtonPrimary onClick={btnSolicitar} >
                                    Solicitar
                                </ButtonPrimary>
                            </Col>
                            {/* {<Col md="2">
                                <ButtonPrimary onClick={btnImprimir} >
                                    Imprimir
                                </ButtonPrimary>
                            </Col>} */}

                        </Row>
                    )
                }

                <UltAlt>{formData.sd48du}</UltAlt>
            </FormContainer>
        </AppLayout>
    )
}